export default __webpack_public_path__ + "static/media/nocompany.5248a8e8.jpg";